import { SetupScreenId } from '../config/setupQuestions';
import { addDays, DayFacts, getDayFacts } from './jewishCalendar';
import { getMinyanDayTags } from './minyanDay';

/** When each set-up screen's kind of day next happens (shown as "Next: …"). */
const FIRST_DAY: Record<SetupScreenId, (f: DayFacts, date: string) => boolean> = {
  weekday: (_f, d) => getMinyanDayTags(d).includes('weekday'),
  monThu: (_f, d) => getMinyanDayTags(d).includes('sheniHamishi'),
  friday: (f) => f.erevShabbos,
  shabbos: (f) => f.shabbos,
  roshChodesh: (f) => f.roshChodesh && !f.yomTov,
  chanukah: (f) => f.chanukahDay === 1,
  fasts: (f) => !!f.minorFast,
  purim: (f) => f.purim,
  beinHazmanim: (f, d) => f.beinHazmanim && getMinyanDayTags(d).includes('weekday'),
  selichot: (f) => f.sefardiSelichotSeason || f.selichotFirstNight,
  yomTov: (f) => f.erevYomTov && !f.cholHaMoed,
  roshHashana: (f) => f.roshHashanaDay === 1,
  yomKippur: (f) => f.erevYomKippur,
  sukkot: (f) => f.specificYomTov === 'sukkotI',
  pesach: (f) => f.specificYomTov === 'pesachI',
  shavuot: (f) => f.specificYomTov === 'shavuot',
  tishaBav: (f) => f.erevTishaBav,
};

/** The next date (from `today`, inclusive) this screen's day happens, within ~13 months; null if none. */
export function nextDateForScreen(screen: SetupScreenId, today: string): string | null {
  let d = today;
  for (let i = 0; i < 400; i += 1) {
    if (FIRST_DAY[screen](getDayFacts(d), d)) return d;
    d = addDays(d, 1);
  }
  return null;
}
